import {Component, Input} from '@angular/core';
import {Menu} from '@core/modules/layout/interfaces/menu.interface';
import {ModalService} from '@shared/modules/modal/services/modal.service';
import {RouterService} from '@shared/services/router.service';

@Component({
  selector: 'app-menu-horizontal-submenu',
  templateUrl: './menu-horizontal-submenu.component.html',
  styleUrls: ['./menu-horizontal-submenu.component.scss']
})
export class MenuHorizontalSubmenuComponent {
  @Input() children: Menu[] = [];

  constructor(
    private modal: ModalService,
    private routerService: RouterService
  ) {}

  close(): void {
    this.modal.close();
  }

  isRouteActive(item: Menu): boolean {
    return this.routerService.isActiveRoute(item.link, !item.children);
  }
}
